import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.updateIcon()
  }

  toggle() {
    const isDark = document.documentElement.classList.toggle("dark")
    document.cookie = `theme=${isDark ? "dark" : "light"};path=/;max-age=${365 * 24 * 60 * 60};SameSite=Lax`
    this.updateIcon()
  }

  updateIcon() {
    const isDark = document.documentElement.classList.contains("dark")
    this.iconTarget.textContent = isDark ? "\u2600\uFE0F" : "\uD83C\uDF19"
  }
}
